import { EArticleGroup } from '@common/article-catalog';

// Подписи групп статей блога. Те же строки показывает панель калькулятора, поэтому они живут в
// переводах и после переезда статей в хранилище.
export const BLOG_GROUP_LABELS: Record<EArticleGroup, string> = {
    [EArticleGroup.StairType]: $localize`:@@labelStairType:Тип лестницы`,
    [EArticleGroup.Room]: $localize`:@@sectionRoom:Помещение`,
    [EArticleGroup.Opening]: $localize`:@@sectionOpening:Проём`,
    [EArticleGroup.Stair]: $localize`:@@sectionStair:Лестница`,
    [EArticleGroup.Railing]: $localize`:@@sectionRailing:Ограждения`,
    [EArticleGroup.Materials]: $localize`:@@sectionMaterials:Материалы`,
    [EArticleGroup.Result]: $localize`:@@sectionResults:Результат расчёта`,
};
